import React, { /*useState,*/ useEffect } from 'react';
/*import { Link } from 'react-router-dom';*/
import { Row, Col, Alert,} from 'react-bootstrap';
import { Loading } from './Loading';
import TimedDisplay from '../components/TimedDisplay';
import { ConfirmModal } from '../components/ConfirmModal';
import RoleUtils from '../utils/roleUtils.js';
import RequestUtils from '../utils/requestUtils.js';
import ServiceCalls from '../utils/serviceCalls.js';
import CommonUtils from "../utils/siteUtils";
import EarlyWarningRejectPopUp from './EarlyWarningRejectPopUp';
import ResubmitEarlyWarningPopup from './ResubmitEarlyWarningPopup';
import PaymentMethodPopUp from './PaymentMethodPopUp';
import AddCommentPopUp from './AddCommentPopUp'; 
import '../styles/Vendor.css';


export const RequestActionButtons =(props) => {
    
    const [isLoading, setIsLoading] = React.useState(true);
    const [isAdmin, setIsAdmin] = React.useState(false);    
    const [hasWorklistRole, setHasWorklistRole] = React.useState(false);    
    const [requestStatus, setRequestStatus] = React.useState(0);
    const [currentRequest, setCurrentRequest] = React.useState(0); 
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const [isSubmitComplete, setIsSubmitComplete] = React.useState(false); 
    const [submitMsg, setSubmitMsg] = React.useState('');
    const [submitMsgLvl, setSubmitMsgLvl] = React.useState('');
    const [showConfirm, setShowConfirm] = React.useState(false);
    const [showRejectPopup, setShowRejectPopup] = React.useState(false);
    const [showResubmitPopup, setShowResubmitPopup] = React.useState(false);
    const [isEMEASupplier, setIsEMEASupplier] = React.useState(false);  
    const [showSubmitEWButton, setShowSubmitEWButton] = React.useState(false);
    const [showResubmitEWButton, setShowResubmitEWButton] = React.useState(false);
    const [pendingApproveArgs, setPendingApproveArgs] = React.useState(null);
    const [showAddCommentPopup, setShowAddCommentPopup] = React.useState(false);
    const [pendingAction, setPendingAction] = React.useState(null); // "pendingclient" or "reject"
    const [pendingRejectSendMail, setPendingRejectSendMail] = React.useState(false);


    useEffect(() => {        
        if (props.currentRequest.bankRequest) {
            if (JSON.stringify(props.currentRequest.bankRequest) !== JSON.stringify(currentRequest.bankRequest)) {
                var hasAdminAccess = RoleUtils.canAccess(props.currentUser, props.currentCompanyId, RoleUtils.optumWorklistOnlyRole());
                var hasWLAccess = RoleUtils.canAccess(props.currentUser, props.currentCompanyId, RoleUtils.allWorklistRoles());
                var isEMEAVendor = CommonUtils.determineIfVendorIsEMEAPlus(props.currentRequest.vendorRecord);
                var requestType = RequestUtils.determineRequestType(props.currentRequest.bankRequest.requestTypeId);
                setCurrentRequest(props.currentRequest);
                setRequestStatus(props.currentRequest.bankRequest.requestStatusId)
                setIsAdmin(hasAdminAccess);
                setHasWorklistRole(hasWLAccess);
                setIsEMEASupplier(isEMEAVendor);

                const { mostRecentCall, mostRecentScore } = RequestUtils.getMostRecentEarlyWarningScoreAndCall(props.currentRequest.bankRequest);
                const hasHighScore = mostRecentScore >= 97;
                const hasValidScore = mostRecentScore !== "N/A" && mostRecentScore !== -1;

                setShowSubmitEWButton(!hasHighScore && !hasValidScore);
                //DE1072063 - Hide Resubmit EW button for EMEA Suppliers and Cancel type requests
                setShowResubmitEWButton(!hasHighScore && hasValidScore && !isEMEAVendor && (requestType !== "CANCEL"));
                
                setIsLoading(false);               
            }
        }
    }, [props.currentRequest, props.currentUser, props.currentCompanyId, currentRequest.bankRequest]);

    const onActionBtnClick = (event) => {

        var btnId = event.target.id;        
        var requestId = props.currentRequest.bankRequest.vendorBankRequestId;
        var vendorRecordId = props.currentRequest.bankRequest.vendorRecordId;
        var requestTypeId = props.currentRequest.bankRequest.requestTypeId;
        console.log(`Button clicked with ID ${btnId} for Request ${requestId} of type: ${requestTypeId}`);
       
        switch (btnId.toUpperCase()) {
            case "APPROVEBTN":
                console.log(`Approve request ${requestId}`);
                const isEMEA = CommonUtils.determineIfVendorIsEMEAPlus(props.currentRequest.vendorRecord);
                const requestTypeStr = RequestUtils.determineRequestType(props.currentRequest.bankRequest.requestTypeId);
                const currentPaymentMethod = props.currentRequest.vendorRecord.vendorPayments?.[0]?.paymentMethod;
                const requestPaymentMethod = props.currentRequest.bankRequest.paymentMethod;
                //Business Does not want payment method change
                //US8847423 Allow Payment Method Change EMEA+
                //if (isEMEA && requestTypeStr === "UPDATE") {
                //   setPendingApproveArgs({ vendorRecordId, requestId, currentPaymentMethod });
                //    setPaymentMethodMode("select"); // EMEA+ gets select mode
                //    setShowPaymentMethodWarning(true);
                //    break;
                //} else
                //US8466209 & US9016057 show warning message if payment method doesn't match
                let showWarning = false;

                if (requestTypeStr === "UPDATE" && requestPaymentMethod != null) {
                    if (isEMEA) {
                        showWarning = currentPaymentMethod !== requestPaymentMethod;
                    } else {
                        showWarning = currentPaymentMethod !== "ACH";
                    }
                }

                if (showWarning) {
                    setPendingApproveArgs({ vendorRecordId, requestId });
                    setPaymentMethodMode("warning");
                    setShowPaymentMethodWarning(true);
                } else {
                    onRequestApprove(vendorRecordId, requestId);
                }
                break;
            case "INPROCESSBTN":
                console.log(`In Process request ${requestId}`);
                onRequestUpdate(vendorRecordId,requestId,4);
                break;
            case "PENDINGCLIENTBTN":
                console.log(`Pending Client request ${requestId}`);
                //Display AddCommentPopup for pending client 
                setPendingAction("pendingclient");
                setShowAddCommentPopup(true);
                break;
            case "REJECTBTN":
                const requestType = RequestUtils.determineRequestType(Number(requestTypeId));
                var isEMEAVendor = CommonUtils.determineIfVendorIsEMEAPlus(props.currentRequest.vendorRecord);
                if (requestType === "CANCEL") {
                    onRequestReject(false);
                } else if (!isEMEAVendor) {
                    //US7587671 - UHGID Set ID gets pop up - non UHGHID is sent rejection email
                    //DE1000904 Determine of Vendor Is EMEA (new criteria)
                    setShowRejectPopup(true); // Show the reject confirmation popup first
                } else {
                    // EMEA Vendor
                    setPendingAction("reject");
                    
                    setShowAddCommentPopup(true);
                }
                break;
            case "RESUBMITBTN":
                console.log(`Resubmit request ${requestId}`);
                //Send new status to Server to handle the AP notifications
                onRequestUpdate(vendorRecordId, requestId, 1);
                break;
            case "CANCELBTN":
                console.log(`Cancel request ${requestId}`);
                setShowConfirm(true);
                break;
            case "SUBMITEWBTN":
                console.log(`Submit Early Warning request ${requestId}`);
                onRequestSubmitEW();
                break;
            case "RESUBMITEWBTN":
                console.log(`Resubmit Early Warning request ${requestId}`);
                setShowResubmitPopup(true);
                break;
            default:
                console.log(`Invalid button click ${btnId}`);
        }
    }

    const [showPaymentMethodWarning, setShowPaymentMethodWarning] = React.useState(false);
    const [paymentMethodMode, setPaymentMethodMode] = React.useState("warning");
    //REMOVED 7-10-25 = Business Does not want payment method change
    const handlePaymentMethodYes = (paymentChanged) => {
       if (pendingApproveArgs) {
          // if (paymentMethodMode === "select") {
          //     onRequestApprove(
          //          pendingApproveArgs.vendorRecordId,
          //         pendingApproveArgs.requestId,
          //         paymentChanged // true if changed, false if not
          //     );
          // } else {
               onRequestApprove(pendingApproveArgs.vendorRecordId, pendingApproveArgs.requestId);
           // }
        }
       setShowPaymentMethodWarning(false);
        setPendingApproveArgs(null);
    };

    const handlePaymentMethodNo = () => {
        setShowPaymentMethodWarning(false);
        setPendingApproveArgs(null);
    };

    const onRequestSubmitEW = () => {  
        console.log(`Submitting Early Warning Score request...`);  
        setIsSubmitting(true);  
        ServiceCalls.getEarlyWarningScore(props.currentRequest).then(function (data) {  
            var errLvl = (data.isSuccessful) ? "info" : "danger";  
            var msg = (data.isSuccessful) ? "Successfully Updated EW Score" : "Error Updating EW Score";  
            setSubmitMsg(msg);  
            setSubmitMsgLvl(errLvl);  
            setIsSubmitting(false);  
            setIsSubmitComplete(true);  
        }).catch(error => {  
            console.error(`Error in onRequestSubmitEW: ${error}`);  
        });  
    }  

    const onRequestApprove = (vendorRecordId, requestId) => {
        if (isNaN(requestId)) {
            console.log(`Invalid Request ID passed in ${requestId}`);
        }
        else {
            console.log(`Approving Request ID passed in ${requestId}`);
            setIsSubmitting(true);

            // US8847423 - Pass in True or False for EMEA Update request if Payment Change is needed.
            // 7-10-25 - Business Does not want to change Payment Method previously passed in requiresEMEAPaymentMethodChangeb
            ServiceCalls.approveBankRequest(vendorRecordId, requestId).then(function (result) {
                //Validate results       
                if (result) {
                    var errLvl = (result.isSuccessful) ? "info" : "danger";
                    var msg = (result.isSuccessful) ? `Successfully Approved Request` : `Error Approving Request - ${result.errorMsg}`;
                    setSubmitMsg(msg);
                    setSubmitMsgLvl(errLvl);
                    setIsSubmitting(false);
                    setIsSubmitComplete(true);
                }
                else {
                    console.log(`No approval result for ${requestId}`);
                }
            });

        }
    }
    const onRequestReject = (sendMail) => {
        var request = props.currentRequest;
        if (isNaN(request.bankRequest.vendorBankRequestId)) {
            console.log(`Invalid Request ID passed in ${request.bankRequest.vendorBankRequestId}`);
        }
        else {
            console.log(`Rejecting Request ID passed in ${request.bankRequest.vendorBankRequestId}`);
            var rejectData = {
                // DE828641 Additional Audit Details
                currentContact: props.currentUser,
                vendorId: request.vendorRecord.vendorId,
                vendorSetId: request.vendorRecord.vendorSetId,
                supplierName: request.vendorRecord.name,
                vendorRecordId: request.bankRequest.vendorRecordId,
                requestId: request.bankRequest.vendorBankRequestId,
                requestorEmail: request.requestor.email,
                requestorName: request.requestor.firstName + " " + request.requestor.lastName,
                signatoryEmail: request.bankRequest.signatoryEmail,
                signatoryName: request.bankRequest.signatoryFirstName + " " + request.bankRequest.signatoryLastName,
                emailFlag: sendMail
            };
        
            setIsSubmitting(true);
            ServiceCalls.rejectBankRequest(rejectData).then(function (result) {
                //Validate results                    
                var errLvl = (result.isSuccessful) ? "info" : "danger";
                var msg = (result.isSuccessful) ? `Successfully Rejected Request` : `Error Rejecting Request- ${result.errorMsg}`;

                setSubmitMsg(msg);
                setSubmitMsgLvl(errLvl);
                setIsSubmitting(false);
                setIsSubmitComplete(true);
            });
            
        }
    }
    const onRequestUpdate = (vendorRecordId, requestId, newStatusId) => {
        if (isNaN(requestId) || isNaN(newStatusId) ) {
            console.log(`Invalid Request ID or Status Id passed in Request Id ${requestId}  Status id: ${newStatusId}`);
        }
        else {
            console.log(`Updating Request ID ${requestId} with a status of ${newStatusId}`);
            setIsSubmitting(true);
            ServiceCalls.updateBankRequest(vendorRecordId, requestId, newStatusId).then(function (result) {
                //Validate results                    
                var errLvl = (result.isSuccessful) ? "info" : "danger";
                var msg = (result.isSuccessful) ? `Successfully Updated Request` : `Error Updating Request- ${result.errorMsg}`;
                setSubmitMsg(msg);
                setSubmitMsgLvl(errLvl);
                setIsSubmitting(false);
                setIsSubmitComplete(true);
            });
        }
    }  


    //US8797469 display AddCommentPopup for pending and reject Button
    const handleAddCommentComplete = () => {
        if (pendingAction === "pendingclient") {
            const vendorRecordId = props.currentRequest.bankRequest.vendorRecordId;
            const requestId = props.currentRequest.bankRequest.vendorBankRequestId;
            onRequestUpdate(vendorRecordId, requestId, 3);
        } else if (pendingAction === "reject") {
            // For EMEA vendor,  sendMail = true; for others, use pendingRejectSendMail
            const isEMEAVendor = CommonUtils.determineIfVendorIsEMEAPlus(props.currentRequest.vendorRecord);
            onRequestReject(isEMEAVendor ? true : pendingRejectSendMail);
        }

        handleAddCommentPopupClose();
    };

    const handleAddCommentPopupClose = () => {
        setShowAddCommentPopup(false);
        setPendingAction(null);
        setPendingRejectSendMail(false);
    };


    const showAlertMessage =() => {
        console.log(`Showing Alert message ${isSubmitComplete}`);
        if (isSubmitComplete) {
            return (<TimedDisplay delay="3000" callback={props.onRequestAction}>
                <Alert variant={submitMsgLvl}>{submitMsg}</Alert>
            </TimedDisplay>);
        }
        else {
            return (<></>);
        }
    }  
    
    return (
        (isLoading)
            ? <div className="emptyActionCard"><Loading /></div>
            : (isSubmitting)
                ? <Row className="actionBtnRow">
                    <Col sm={{ span: 3, offset: 9 }}>
                        <div className="emptyActionCard">Submitting Update <br /><Loading /></div>
                    </Col>
                </Row>
                : (submitMsg === '')
                    ? <>
                        <ConfirmModal isOpen={showConfirm} handleClose={e => { setShowConfirm(false) }} handleAccept={e => { onRequestUpdate(props.currentRequest.bankRequest.vendorRecordId, props.currentRequest.bankRequest.vendorBankRequestId, 7) }} message="Are you sure you want to cancel this request?" />
                        <Row className="actionBtnRow">
                            <Col sm={{ span: 4, offset: 8 }}>
                                {RequestUtils.getRequestActionButtons(requestStatus, isAdmin, hasWorklistRole, onActionBtnClick, showSubmitEWButton, showResubmitEWButton)}
                                {showRejectPopup && (
                                    <EarlyWarningRejectPopUp
                                        setIsOpen={setShowRejectPopup}
                                        onConfirm={(sendEmail) => {
                                            setShowRejectPopup(false);
                                            setPendingAction("reject");
                                            setPendingRejectSendMail(sendEmail); 
                                            setShowAddCommentPopup(true);
                                        }}
                                        onCancel={() => setShowRejectPopup(false)}
                                        request={props.currentRequest}
                                        currentUser={props.currentUser}
                                    />
                                )}
                                {showResubmitPopup && <ResubmitEarlyWarningPopup setIsOpen={setShowResubmitPopup} request={props.currentRequest} currentUser={props.currentUser} onRequestUpdate={props.onRequestAction} />}
                                {showAddCommentPopup && (
                                    <AddCommentPopUp
                                        currentUser={props.currentUser}
                                        currentCompanyId={props.currentCompanyId}
                                        Request={props.currentRequest}
                                        commentTableLoad={handleAddCommentComplete}
                                        onCancel={handleAddCommentPopupClose}
                                        showButton={() => false}
                                        showPopupOnAction={true}
                                        actionType={pendingAction}
                                    />
                                )}

                                {/* 7-10-25 - Business Does not want to change Payment Method */}
                                {showPaymentMethodWarning && paymentMethodMode === "warning" && (
                                   <PaymentMethodPopUp
                                       setIsOpen={setShowPaymentMethodWarning}
                                       onProceed={handlePaymentMethodYes}
                                        onCancel={handlePaymentMethodNo}
                                       mode={paymentMethodMode}
                                        currentMethod={pendingApproveArgs?.currentPaymentMethod}
                                 />
                                )}

                            </Col>
                        </Row>
                    </>
                    : <Row className="actionBtnRow">
                        <Col sm={{ span: 4, offset: 8 }}>
                            {showAlertMessage()}
                        </Col>
                    </Row>

    );
}

